'use client'
import React, { ReactElement } from 'react'

import getSymbolFromCurrency from 'currency-symbol-map'

import { useTranslation } from '@/hooks/useDebugTranslations'

interface Props {
  currency?: string
  dataAttr?: string
  price?: number
}

const Price: React.FC<Props> = ({ currency, dataAttr, price }): ReactElement => {
  const { t } = useTranslation()

  return (
    <span data-e2e={dataAttr ?? undefined}>
      {t('PRICE', {
        currency: currency === 'MAD' ? 'DH' : currency && getSymbolFromCurrency(currency),
        price: price?.toFixed(2),
      })}
    </span>
  )
}

export default Price
